import { render, staticRenderFns } from "./ModalOpcoes.vue?vue&type=template&id=48a60c16&scoped=true&lang=pug"
import script from "./ModalOpcoes.vue?vue&type=script&lang=js"
export * from "./ModalOpcoes.vue?vue&type=script&lang=js"
import style0 from "./ModalOpcoes.vue?vue&type=style&index=0&id=48a60c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a60c16",
  null
  
)

export default component.exports